/* global document, window */
import React, { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';

(() => {
  let mounted = false;
  // Detect editor
  const isWPBakeryFrontend = () => {
    const qs = window.location.search || '';
    return qs.indexOf('vc_editable=true') !== -1;
  };
  const mount = () => {
    if (mounted) return;
    const root = document.getElementById('cf-post-listing');
    if (!root) {
      setTimeout(mount, 300);
      return;
    }
    mounted = true;
    const path = root.getAttribute('data-path');
    createRoot(root).render(
      <StrictMode>
        <App path={path} />
      </StrictMode>,
    );
  };
  if (isWPBakeryFrontend()) {
    setTimeout(mount, 300);
  } else {
    document.addEventListener('DOMContentLoaded', mount);
  }
})();
